import {successColor, whiteColor, grayColor, hexToRgb} from '../cmsMainStyle'

const dashboardStyle = {
  successText: {
    color: successColor[0]
  },

  upArrowCardCategory: {
    width: "16px",
    height: "16px"
  },

  stats: {
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: grayColor[10],
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    }
  },

  cardCategory: {
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: grayColor[12],
    margin: "0",
    fontSize: "20px",
    marginTop: "0",
    marginBottom: "5px",  
    paddingTop: "10px",
  },

  cardCategoryWhite: {
    color: "rgba(" + hexToRgb(whiteColor) + ",.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },

  cardTitle: {
    color: grayColor[10],
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "600",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[8],
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  
  cardTitleWhite: {
    color: whiteColor,
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

export default dashboardStyle
